import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Matches /requests/{GUID} but not /requests/new/... or /requests alone
const requestDetailPattern = /^\/requests\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Normalizes high-cardinality dynamic routes to their route pattern. */
function normalizePath(path: string): string {
  if (requestDetailPattern.test(path)) return '/requests/:id';
  return path;
}

/**
 * Tracks page views by sending route changes to the backend,
 * which logs them to Application Insights via TelemetryClient.
 * Uses a fire-and-forget POST — tracking failures are silently ignored.
 */
export function usePageTracking() {
  const location = useLocation();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    const page = normalizePath(location.pathname);
    // Skip duplicate tracking (e.g., re-renders without actual navigation)
    if (page === prevPath.current) return;
    prevPath.current = page;

    fetch('/api/telemetry/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ page }),
    }).catch(() => {
      // Silently ignore tracking failures — never block the user
    });
  }, [location.pathname]);
}
